import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { AdvancedModeModule } from '../shared/advanced-mode/advanced-mode.module';
import { SharedModule } from '../shared/shared.module';
import { ClinicalEventListComponent } from './clinical-event-list/clinical-event-list.component';



@NgModule({
  declarations: [
    ClinicalEventListComponent],
  imports: [
    CommonModule,
    BreadcrumbModule,
    AdvancedModeModule,
    SharedModule,
  ]
})
export class ClinicalEventModule { }
